import script from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=0f6c5c1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6c5c1c"]])

export default __exports__